import type { SiteBootstrap } from './types'

const API_BASE = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, init)
  if (!response.ok) {
    const data = await response.json().catch(() => ({ message: 'Request failed' }))
    throw new Error(data.message || `Request failed (${response.status})`)
  }
  return response.json() as Promise<T>
}

export const fetchBootstrap = () => api<SiteBootstrap>('/api/public/bootstrap')
export const submitFormData = <T>(path: string, form: FormData) => api<T>(path, { method: 'POST', body: form })
